// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2XXJ2","logoImage":"styles_logoImage__WzltK","editButton":"styles_editButton__dpze6","hideEditButton":"styles_hideEditButton__lOXYM"};